import { createStandardAction } from 'typesafe-actions';

// XXX: Replace with your own standard action implementation
export const setCallbackUrl = createStandardAction('SET_CALLBACK_URL')<string>();
